import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-t border-[#E10600]/30 p-4 md:p-6">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <h3 className="text-[#E10600] font-bold text-lg mb-2 inline-flex items-center gap-2"><Cookie className="w-5 h-5" strokeWidth={1.5} aria-hidden="true" /> Cookie Notice</h3>
            <p className="text-white text-sm md:text-base">
              We use cookies to enhance your experience, analyze site traffic, and personalize content. 
              By clicking "Accept All", you consent to our use of cookies. Read our{' '}
              <a href="/cookies" className="text-[#E10600] underline hover:text-white transition-colors">
                Cookie Policy
              </a>{' '}
              and{' '}
              <a href="/privacy" className="text-[#E10600] underline hover:text-white transition-colors">
                Privacy Policy
              </a>{' '}
              for more information.
            </p>
          </div>
          
          <div className="flex gap-3 w-full md:w-auto">
            <button
              onClick={handleDecline}
              className="flex-1 md:flex-none btn-outline-gold text-xs md:text-sm px-4 py-2 min-h-[44px]"
              aria-label="Decline cookies"
            >
              Decline
            </button>
            <button
              onClick={handleAccept}
              className="flex-1 md:flex-none btn-gold text-xs md:text-sm px-6 py-2 min-h-[44px]"
              aria-label="Accept all cookies"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;